import { Box } from '@mui/system';
import PricingCalculatorForm from 'components/forms/CarrierFormFactory/PricingCalculatorForm';
import { PricingCalculatorSchemaType } from 'components/forms/CarrierFormFactory/types';
import { ModalBase } from 'remote/global';

import { useTranslation } from 'react-i18next';

type ModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>; // Used to change the open state
  onClose: () => void; // Used to clear the open and component state
  defaultValues?: Partial<PricingCalculatorSchemaType>;
};

function PricingCalculatorModal(props: ModalProps) {
  const { open, setOpen, defaultValues, onClose } = props;
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setOpen(false);
    onClose();
  };

  return (
    <ModalBase
      open={open}
      title={t('modals.priceCalculator.title').toString()}
      description={t('modals.priceCalculator.subtitle').toString()}
      setOpen={setOpen}
      onClose={handleCloseModal}
      maxWidth='lg'
      fullWidth
    >
      <Box p={2}>
        <PricingCalculatorForm defaultValues={defaultValues} />
      </Box>
    </ModalBase>
  );
}

export default PricingCalculatorModal;
